import '../utilities/library-loader';
Avatar.theme = Avatar.theme || {};

Avatar.theme.ProductModel = function () {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors = {
    sectionById: function sectionById(id) {
      return "#shopify-section-".concat(id);
    },
    productMediaTypeModel: '[data-product-media-type-model]',
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]',
    modelViewer: '.model-viewer',
    jsonModelById: function jsonModelById(id) {
      return "#ModelJson-".concat(id);
    }
  };
  var attributes = {
    mediaId: 'data-media-id',
    modelId: 'data-model-id'
  };

  function init(sectionId) {
    var section = document.querySelector(selectors.sectionById(sectionId));
    var modelViewerContainers = section.querySelectorAll(selectors.productMediaTypeModel);
    if (modelViewerContainers.length < 1) return;
    modelJsonSections[sectionId] = {
      loaded: false
    };
    modelViewerContainers.forEach(function (modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute(attributes.mediaId);
      var modelViewerElement = modelViewerContainer.querySelector(selectors.modelViewer);
      var modelId = modelViewerElement.getAttribute(attributes.modelId);

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });
    window.Shopify.loadFeatures([{
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr
    }, {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi
    }]);
    Avatar.theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function () {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;
        var modelJson = document.querySelector(selectors.jsonModelById(sectionId));
        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }

    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) {
      return;
    }

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];

        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }

        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.container.addEventListener('mediaVisible', function (evt) {
      xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
      var swiper = evt.detail.swiper;
      swiper.allowTouchMove = false;
    });
    model.container.addEventListener('mediaHidden', function (evt) {
      xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
      var swiper = evt.detail.swiper;
      swiper.allowTouchMove = true;
    });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];

        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }

    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
}();